[
  {
    "culture": "Abua",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Abua",
    "location_description": "Abua-Odual LGA, Rivers State, Niger Delta region of Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 4.8,
      "lon": 6.4
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6.2, 4.6],
          [6.6, 4.6],
          [6.6, 5],
          [6.2, 5],
          [6.2, 4.6]
        ]
      ]
    }
  },
  {
    "culture": "Adio",
    "wikipedia_url": null,
    "location_description": "Information not readily available",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Limited documentation available"
  },
  {
    "culture": "African",
    "wikipedia_url": "https://en.wikipedia.org/wiki/African_people",
    "location_description": "Entire African continent",
    "countries": ["Multiple - continental"],
    "coordinates": {
      "lat": 0,
      "lon": 20
    },
    "geojson": null,
    "notes": "General category, not a specific culture"
  },
  {
    "culture": "African Americans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/African_Americans",
    "location_description": "United States",
    "countries": ["United States"],
    "coordinates": {
      "lat": 38,
      "lon": -97
    },
    "geojson": null,
    "notes": "Diaspora population, not native to Africa"
  },
  {
    "culture": "Africans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/African_people",
    "location_description": "Entire African continent",
    "countries": ["Multiple - continental"],
    "coordinates": {
      "lat": 0,
      "lon": 20
    },
    "geojson": null,
    "notes": "General category, not a specific culture"
  },
  {
    "culture": "Ainu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ainu_people",
    "location_description": "Hokkaido, Japan",
    "countries": ["Japan"],
    "coordinates": {
      "lat": 43,
      "lon": 142
    },
    "geojson": null,
    "notes": "Indigenous people of Japan, not African"
  },
  {
    "culture": "Akan",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Akan_people",
    "location_description": "Southern and central Ghana, eastern Ivory Coast, parts of Togo",
    "countries": ["Ghana", "Ivory Coast", "Togo"],
    "coordinates": {
      "lat": 6.5,
      "lon": -1.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-3, 5],
          [0.5, 5],
          [0.5, 8.5],
          [-3, 8.5],
          [-3, 5]
        ]
      ]
    }
  },
  {
    "culture": "Akela",
    "wikipedia_url": null,
    "location_description": "Information not readily available",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Limited documentation available"
  },
  {
    "culture": "Akoko",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Akoko",
    "location_description": "Ondo State, southwestern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.5,
      "lon": 5.8
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5.5, 7.2],
          [6.1, 7.2],
          [6.1, 7.8],
          [5.5, 7.8],
          [5.5, 7.2]
        ]
      ]
    }
  },
  {
    "culture": "Amhara",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Amhara_people",
    "location_description": "Ethiopian Highlands, Amhara Region, Ethiopia",
    "countries": ["Ethiopia"],
    "coordinates": {
      "lat": 11.5,
      "lon": 38
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [36.5, 10],
          [40, 10],
          [40, 13],
          [36.5, 13],
          [36.5, 10]
        ]
      ]
    }
  },
  {
    "culture": "Anga",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Anga_people",
    "location_description": "Papua New Guinea",
    "countries": ["Papua New Guinea"],
    "coordinates": {
      "lat": -6.5,
      "lon": 145.5
    },
    "geojson": null,
    "notes": "Not African - located in Papua New Guinea"
  },
  {
    "culture": "Aro",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Aro_people",
    "location_description": "Arochukwu, Abia State, southeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 5.4,
      "lon": 7.9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [7.7, 5.2],
          [8.1, 5.2],
          [8.1, 5.6],
          [7.7, 5.6],
          [7.7, 5.2]
        ]
      ]
    }
  },
  {
    "culture": "Asante",
    "alternate_names": ["Ashanti"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ashanti_people",
    "location_description": "Ashanti Region, south-central Ghana",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 6.7,
      "lon": -1.6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-2.5, 6],
          [-0.5, 6],
          [-0.5, 7.5],
          [-2.5, 7.5],
          [-2.5, 6]
        ]
      ]
    }
  },
  {
    "culture": "Ashanti",
    "alternate_names": ["Asante"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ashanti_people",
    "location_description": "Ashanti Region, south-central Ghana",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 6.7,
      "lon": -1.6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-2.5, 6],
          [-0.5, 6],
          [-0.5, 7.5],
          [-2.5, 7.5],
          [-2.5, 6]
        ]
      ]
    }
  },
  {
    "culture": "Azande",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Azande_people",
    "location_description": "Northern Democratic Republic of Congo, South Sudan, Central African Republic",
    "countries": [
      "Democratic Republic of Congo",
      "South Sudan",
      "Central African Republic"
    ],
    "coordinates": {
      "lat": 5,
      "lon": 27
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [24, 3],
          [30, 3],
          [30, 7],
          [24, 7],
          [24, 3]
        ]
      ]
    }
  },
  {
    "culture": "Babembe",
    "alternate_names": ["Bembe"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bembe_people",
    "location_description": "Eastern Democratic Republic of Congo, western Tanzania",
    "countries": ["Democratic Republic of Congo", "Tanzania"],
    "coordinates": {
      "lat": -4.5,
      "lon": 29
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [28, -5.5],
          [30, -5.5],
          [30, -3.5],
          [28, -3.5],
          [28, -5.5]
        ]
      ]
    }
  },
  {
    "culture": "Baga",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Baga_people",
    "location_description": "Coastal Guinea",
    "countries": ["Guinea"],
    "coordinates": {
      "lat": 10.5,
      "lon": -14
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-14.5, 10],
          [-13.5, 10],
          [-13.5, 11],
          [-14.5, 11],
          [-14.5, 10]
        ]
      ]
    }
  },
  {
    "culture": "Bakongo",
    "alternate_names": ["Kongo"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kongo_people",
    "location_description": "Lower Congo River, DRC, Republic of Congo, Angola",
    "countries": [
      "Democratic Republic of Congo",
      "Republic of Congo",
      "Angola"
    ],
    "coordinates": {
      "lat": -4.5,
      "lon": 15
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [12, -6],
          [18, -6],
          [18, -3],
          [12, -3],
          [12, -6]
        ]
      ]
    }
  },
  {
    "culture": "Bamana",
    "alternate_names": ["Bambara"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bambara_people",
    "location_description": "Central and southern Mali",
    "countries": ["Mali"],
    "coordinates": {
      "lat": 13,
      "lon": -7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-9, 11],
          [-5, 11],
          [-5, 15],
          [-9, 15],
          [-9, 11]
        ]
      ]
    }
  },
  {
    "culture": "Bamum",
    "alternate_names": ["Bamoun"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bamum_people",
    "location_description": "West Region, Cameroon",
    "countries": ["Cameroon"],
    "coordinates": {
      "lat": 5.7,
      "lon": 10.8
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [10.4, 5.4],
          [11.2, 5.4],
          [11.2, 6],
          [10.4, 6],
          [10.4, 5.4]
        ]
      ]
    }
  },
  {
    "culture": "Bangala",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bangala_people",
    "location_description": "Northwestern Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": 1.5,
      "lon": 21
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [19, 0.5],
          [23, 0.5],
          [23, 2.5],
          [19, 2.5],
          [19, 0.5]
        ]
      ]
    }
  },
  {
    "culture": "Bangwa",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bangwa_people",
    "location_description": "Southwest Region, Cameroon",
    "countries": ["Cameroon"],
    "coordinates": {
      "lat": 5.7,
      "lon": 9.9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [9.6, 5.5],
          [10.2, 5.5],
          [10.2, 5.9],
          [9.6, 5.9],
          [9.6, 5.5]
        ]
      ]
    }
  },
  {
    "culture": "Bantu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bantu_peoples",
    "location_description": "Sub-Saharan Africa - from Cameroon to South Africa",
    "countries": ["Multiple - 27+ countries"],
    "coordinates": {
      "lat": -5,
      "lon": 25
    },
    "geojson": null,
    "notes": "Large linguistic group spanning most of sub-Saharan Africa"
  },
  {
    "culture": "Bantu-speaking peoples",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bantu_peoples",
    "location_description": "Sub-Saharan Africa - from Cameroon to South Africa",
    "countries": ["Multiple - 27+ countries"],
    "coordinates": {
      "lat": -5,
      "lon": 25
    },
    "geojson": null,
    "notes": "Large linguistic group spanning most of sub-Saharan Africa"
  },
  {
    "culture": "Bapoto",
    "alternate_names": ["Poto"],
    "wikipedia_url": null,
    "location_description": "Northwestern Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": 1,
      "lon": 21
    },
    "geojson": null,
    "notes": "Limited documentation"
  },
  {
    "culture": "Bapunu",
    "alternate_names": ["Punu"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Punu_people",
    "location_description": "Southern Gabon, Republic of Congo",
    "countries": ["Gabon", "Republic of Congo"],
    "coordinates": {
      "lat": -2.5,
      "lon": 11.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [10.5, -3.5],
          [12.5, -3.5],
          [12.5, -1.5],
          [10.5, -1.5],
          [10.5, -3.5]
        ]
      ]
    }
  },
  {
    "culture": "Baule",
    "alternate_names": ["Baoulé"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Baoulé_people",
    "location_description": "Central Ivory Coast",
    "countries": ["Ivory Coast"],
    "coordinates": {
      "lat": 7,
      "lon": -5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-6, 6],
          [-4, 6],
          [-4, 8],
          [-6, 8],
          [-6, 6]
        ]
      ]
    }
  },
  {
    "culture": "Bawongo",
    "wikipedia_url": null,
    "location_description": "Information not readily available",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Limited documentation available"
  },
  {
    "culture": "Bayanzi",
    "alternate_names": ["Yanzi"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Yanzi_people",
    "location_description": "Mai-Ndombe Province, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -2.5,
      "lon": 18.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [17.5, -3.5],
          [19.5, -3.5],
          [19.5, -1.5],
          [17.5, -1.5],
          [17.5, -3.5]
        ]
      ]
    }
  },
  {
    "culture": "Bemba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bemba_people",
    "location_description": "Northern Zambia, southeastern Democratic Republic of Congo",
    "countries": ["Zambia", "Democratic Republic of Congo"],
    "coordinates": {
      "lat": -10.5,
      "lon": 30
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [28, -12],
          [32, -12],
          [32, -9],
          [28, -9],
          [28, -12]
        ]
      ]
    }
  },
  {
    "culture": "Bena",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bena_people",
    "location_description": "Njombe Region, Tanzania",
    "countries": ["Tanzania"],
    "coordinates": {
      "lat": -9,
      "lon": 35
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [34.5, -9.5],
          [35.5, -9.5],
          [35.5, -8.5],
          [34.5, -8.5],
          [34.5, -9.5]
        ]
      ]
    }
  },
  {
    "culture": "Bena Biombo",
    "wikipedia_url": null,
    "location_description": "Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -5,
      "lon": 23
    },
    "geojson": null,
    "notes": "Limited documentation"
  },
  {
    "culture": "Blacks",
    "wikipedia_url": null,
    "location_description": "Global",
    "countries": ["Multiple - global"],
    "coordinates": null,
    "geojson": null,
    "notes": "Racial category, not a specific culture"
  },
  {
    "culture": "Boer",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Boers",
    "location_description": "South Africa, Namibia",
    "countries": ["South Africa", "Namibia"],
    "coordinates": {
      "lat": -28,
      "lon": 25
    },
    "geojson": null,
    "notes": "Afrikaner ethnic group of European descent"
  },
  {
    "culture": "Brong",
    "alternate_names": ["Bono"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Bono_people",
    "location_description": "Bono Region, Ghana",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 7.5,
      "lon": -2.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-3.5, 6.5],
          [-1.5, 6.5],
          [-1.5, 8.5],
          [-3.5, 8.5],
          [-3.5, 6.5]
        ]
      ]
    }
  },
  {
    "culture": "Budu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Budu_people",
    "location_description": "Ituri Province, northeastern Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": 2,
      "lon": 28.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [27.5, 1],
          [29.5, 1],
          [29.5, 3],
          [27.5, 3],
          [27.5, 1]
        ]
      ]
    }
  },
  {
    "culture": "Bushongo",
    "alternate_names": ["Kuba"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kuba_Kingdom",
    "location_description": "Kasai region, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -5,
      "lon": 21
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [20, -6],
          [22, -6],
          [22, -4],
          [20, -4],
          [20, -6]
        ]
      ]
    }
  },
  {
    "culture": "Byzantine",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Byzantine_Empire",
    "location_description": "Eastern Mediterranean, primarily modern Turkey and Greece",
    "countries": ["Multiple - Mediterranean region"],
    "coordinates": {
      "lat": 39,
      "lon": 35
    },
    "geojson": null,
    "notes": "Not African - Eastern Roman Empire culture"
  },
  {
    "culture": "Central African",
    "wikipedia_url": null,
    "location_description": "Central Africa region",
    "countries": ["Multiple - Central Africa"],
    "coordinates": {
      "lat": 0,
      "lon": 20
    },
    "geojson": null,
    "notes": "General regional category, not a specific culture"
  },
  {
    "culture": "Cewa",
    "alternate_names": ["Chewa"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Chewa_people",
    "location_description": "Malawi, Zambia, Mozambique",
    "countries": ["Malawi", "Zambia", "Mozambique"],
    "coordinates": {
      "lat": -14,
      "lon": 33
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [31, -16],
          [35, -16],
          [35, -12],
          [31, -12],
          [31, -16]
        ]
      ]
    }
  },
  {
    "culture": "Chamba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Chamba_people",
    "location_description": "Nigeria-Cameroon border region",
    "countries": ["Nigeria", "Cameroon"],
    "coordinates": {
      "lat": 8.5,
      "lon": 11.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [11, 8],
          [12, 8],
          [12, 9],
          [11, 9],
          [11, 8]
        ]
      ]
    }
  },
  {
    "culture": "Chewa",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Chewa_people",
    "location_description": "Malawi, Zambia, Mozambique",
    "countries": ["Malawi", "Zambia", "Mozambique"],
    "coordinates": {
      "lat": -14,
      "lon": 33
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [31, -16],
          [35, -16],
          [35, -12],
          [31, -12],
          [31, -16]
        ]
      ]
    }
  },
  {
    "culture": "Christians",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Christianity",
    "location_description": "Global",
    "countries": ["Multiple - global"],
    "coordinates": null,
    "geojson": null,
    "notes": "Religious category, not a specific culture"
  },
  {
    "culture": "Cikunda",
    "alternate_names": ["Kunda"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kunda_people",
    "location_description": "Mozambique, Zimbabwe",
    "countries": ["Mozambique", "Zimbabwe"],
    "coordinates": {
      "lat": -16,
      "lon": 32
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [30, -18],
          [34, -18],
          [34, -14],
          [30, -14],
          [30, -18]
        ]
      ]
    }
  },
  {
    "culture": "Cubans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Cubans",
    "location_description": "Cuba",
    "countries": ["Cuba"],
    "coordinates": {
      "lat": 21.5,
      "lon": -79
    },
    "geojson": null,
    "notes": "Not African - Caribbean nation"
  },
  {
    "culture": "Dan",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Dan_people",
    "location_description": "Western Ivory Coast, eastern Liberia",
    "countries": ["Ivory Coast", "Liberia"],
    "coordinates": {
      "lat": 7.5,
      "lon": -7.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-8.5, 6.5],
          [-6.5, 6.5],
          [-6.5, 8.5],
          [-8.5, 8.5],
          [-8.5, 6.5]
        ]
      ]
    }
  },
  {
    "culture": "Djerma",
    "alternate_names": ["Zarma"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Zarma_people",
    "location_description": "Southwestern Niger, northern Nigeria, Benin, Burkina Faso",
    "countries": ["Niger", "Nigeria", "Benin", "Burkina Faso"],
    "coordinates": {
      "lat": 13.5,
      "lon": 2
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [0, 12],
          [4, 12],
          [4, 15],
          [0, 15],
          [0, 12]
        ]
      ]
    }
  },
  {
    "culture": "Dogon",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Dogon_people",
    "location_description": "Bandiagara Escarpment, central Mali",
    "countries": ["Mali"],
    "coordinates": {
      "lat": 14.5,
      "lon": -3.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-4.5, 13.5],
          [-2.5, 13.5],
          [-2.5, 15.5],
          [-4.5, 15.5],
          [-4.5, 13.5]
        ]
      ]
    }
  },
  {
    "culture": "Duala",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Duala_people",
    "location_description": "Littoral Region, Cameroon",
    "countries": ["Cameroon"],
    "coordinates": {
      "lat": 4,
      "lon": 9.7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [9.3, 3.5],
          [10.1, 3.5],
          [10.1, 4.5],
          [9.3, 4.5],
          [9.3, 3.5]
        ]
      ]
    }
  },
  {
    "culture": "Ebira",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ebira_people",
    "location_description": "Central Nigeria, Kogi State",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.7,
      "lon": 6.7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6.3, 7.3],
          [7.1, 7.3],
          [7.1, 8.1],
          [6.3, 8.1],
          [6.3, 7.3]
        ]
      ]
    }
  },
  {
    "culture": "Edo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Edo_people",
    "location_description": "Edo State, southern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 6.3,
      "lon": 5.6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5, 5.8],
          [6.4, 5.8],
          [6.4, 7.2],
          [5, 7.2],
          [5, 5.8]
        ]
      ]
    }
  },
  {
    "culture": "Efik",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Efik_people",
    "location_description": "Cross River State, southeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 4.95,
      "lon": 8.33
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [8, 4.5],
          [8.6, 4.5],
          [8.6, 5.4],
          [8, 5.4],
          [8, 4.5]
        ]
      ]
    }
  },
  {
    "culture": "Egyptian",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Egyptians",
    "location_description": "Egypt, Nile River valley",
    "countries": ["Egypt"],
    "coordinates": {
      "lat": 26,
      "lon": 30
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [25, 22],
          [35, 22],
          [35, 31.5],
          [25, 31.5],
          [25, 22]
        ]
      ]
    }
  },
  {
    "culture": "Ekoi",
    "alternate_names": ["Ejagham"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ekoi_people",
    "location_description": "Cross River State Nigeria, Southwest Cameroon",
    "countries": ["Nigeria", "Cameroon"],
    "coordinates": {
      "lat": 6,
      "lon": 9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [8.5, 5.5],
          [9.5, 5.5],
          [9.5, 6.5],
          [8.5, 6.5],
          [8.5, 5.5]
        ]
      ]
    }
  },
  {
    "culture": "Ethiopians",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ethiopian_people",
    "location_description": "Ethiopia",
    "countries": ["Ethiopia"],
    "coordinates": {
      "lat": 9,
      "lon": 40
    },
    "geojson": null,
    "notes": "General national category, not a specific ethnic group"
  },
  {
    "culture": "Ewe",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ewe_people",
    "location_description": "Southeastern Ghana, southern Togo, southwestern Benin",
    "countries": ["Ghana", "Togo", "Benin"],
    "coordinates": {
      "lat": 6.5,
      "lon": 1.2
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [0, 6],
          [2.5, 6],
          [2.5, 7],
          [0, 7],
          [0, 6]
        ]
      ]
    }
  },
  {
    "culture": "Fang",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Fang_people",
    "location_description": "Southern Cameroon, Equatorial Guinea, northern Gabon",
    "countries": ["Cameroon", "Equatorial Guinea", "Gabon"],
    "coordinates": {
      "lat": 1.5,
      "lon": 10.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [8.5, -1],
          [13, -1],
          [13, 4],
          [8.5, 4],
          [8.5, -1]
        ]
      ]
    }
  },
  {
    "culture": "Fante",
    "alternate_names": ["Fanti"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Fante_people",
    "location_description": "Central Region, Ghana, coastal area",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 5.2,
      "lon": -1
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-2, 4.8],
          [0, 4.8],
          [0, 5.6],
          [-2, 5.6],
          [-2, 4.8]
        ]
      ]
    }
  },
  {
    "culture": "Fon",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Fon_people",
    "location_description": "Southern and central Benin",
    "countries": ["Benin"],
    "coordinates": {
      "lat": 6.5,
      "lon": 2.3
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [1.5, 6],
          [3, 6],
          [3, 7.5],
          [1.5, 7.5],
          [1.5, 6]
        ]
      ]
    }
  },
  {
    "culture": "Fulbe",
    "alternate_names": ["Fulani", "Fula"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Fula_people",
    "location_description": "West Africa - Sahel region from Senegal to Sudan",
    "countries": [
      "Senegal",
      "Guinea",
      "Mali",
      "Burkina Faso",
      "Niger",
      "Nigeria",
      "Cameroon",
      "Chad",
      "Sudan"
    ],
    "coordinates": {
      "lat": 12,
      "lon": 5
    },
    "geojson": null,
    "notes": "Widely dispersed across West Africa Sahel"
  },
  {
    "culture": "Gbari",
    "alternate_names": ["Gbagyi"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Gbagyi_people",
    "location_description": "North-central Nigeria, Niger State, Federal Capital Territory",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 9,
      "lon": 7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6, 8],
          [8, 8],
          [8, 10],
          [6, 10],
          [6, 8]
        ]
      ]
    }
  },
  {
    "culture": "Ghanaian",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ghanaians",
    "location_description": "Ghana",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 7.5,
      "lon": -1
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Griqua",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Griqua_people",
    "location_description": "Northern Cape, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -29,
      "lon": 23
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [21, -31],
          [25, -31],
          [25, -27],
          [21, -27],
          [21, -31]
        ]
      ]
    }
  },
  {
    "culture": "Gusii",
    "alternate_names": ["Kisii"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Gusii_people",
    "location_description": "Kisii County, southwestern Kenya",
    "countries": ["Kenya"],
    "coordinates": {
      "lat": -0.7,
      "lon": 34.8
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [34.5, -1],
          [35.1, -1],
          [35.1, -0.4],
          [34.5, -0.4],
          [34.5, -1]
        ]
      ]
    }
  },
  {
    "culture": "Hausa",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Hausa_people",
    "location_description": "Northern Nigeria, southern Niger",
    "countries": ["Nigeria", "Niger"],
    "coordinates": {
      "lat": 12,
      "lon": 8.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5, 10],
          [12, 10],
          [12, 14],
          [5, 14],
          [5, 10]
        ]
      ]
    }
  },
  {
    "culture": "Ibibio",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ibibio_people",
    "location_description": "Akwa Ibom State, southeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 5,
      "lon": 7.9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [7.5, 4.5],
          [8.4, 4.5],
          [8.4, 5.5],
          [7.5, 5.5],
          [7.5, 4.5]
        ]
      ]
    }
  },
  {
    "culture": "Idoma",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Idoma_people",
    "location_description": "Benue State, central Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.2,
      "lon": 8.3
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [7.8, 6.8],
          [8.8, 6.8],
          [8.8, 7.6],
          [7.8, 7.6],
          [7.8, 6.8]
        ]
      ]
    }
  },
  {
    "culture": "Igala",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Igala_people",
    "location_description": "Kogi State, central Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.5,
      "lon": 7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6.5, 6.5],
          [7.8, 6.5],
          [7.8, 8.5],
          [6.5, 8.5],
          [6.5, 6.5]
        ]
      ]
    }
  },
  {
    "culture": "Igbo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Igbo_people",
    "location_description": "Southeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 6,
      "lon": 7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6, 4.5],
          [8, 4.5],
          [8, 7.5],
          [6, 7.5],
          [6, 4.5]
        ]
      ]
    }
  },
  {
    "culture": "Ijaw",
    "alternate_names": ["Ijo", "Izon"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ijaw_people",
    "location_description": "Niger Delta, southern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 5,
      "lon": 6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5, 4.2],
          [7, 4.2],
          [7, 5.8],
          [5, 5.8],
          [5, 4.2]
        ]
      ]
    }
  },
  {
    "culture": "Ijo",
    "alternate_names": ["Ijaw", "Izon"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ijaw_people",
    "location_description": "Niger Delta, southern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 5,
      "lon": 6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5, 4.2],
          [7, 4.2],
          [7, 5.8],
          [5, 5.8],
          [5, 4.2]
        ]
      ]
    }
  },
  {
    "culture": "Ivorian",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ivorians",
    "location_description": "Ivory Coast",
    "countries": ["Ivory Coast"],
    "coordinates": {
      "lat": 7.5,
      "lon": -5.5
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Jula",
    "alternate_names": ["Dyula"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Dyula_people",
    "location_description": "Northern Ivory Coast, Burkina Faso, Mali",
    "countries": ["Ivory Coast", "Burkina Faso", "Mali"],
    "coordinates": {
      "lat": 9.5,
      "lon": -5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-7, 8],
          [-3, 8],
          [-3, 11],
          [-7, 11],
          [-7, 8]
        ]
      ]
    }
  },
  {
    "culture": "Kaka",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kaka_people_(Cameroon)",
    "location_description": "Eastern Cameroon",
    "countries": ["Cameroon"],
    "coordinates": {
      "lat": 4,
      "lon": 14.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [13.5, 3.5],
          [15, 3.5],
          [15, 4.5],
          [13.5, 4.5],
          [13.5, 3.5]
        ]
      ]
    }
  },
  {
    "culture": "Kalabari",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kalabari_people",
    "location_description": "Rivers State, Niger Delta, Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 4.7,
      "lon": 6.9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6.6, 4.5],
          [7.2, 4.5],
          [7.2, 4.9],
          [6.6, 4.9],
          [6.6, 4.5]
        ]
      ]
    }
  },
  {
    "culture": "Kamba",
    "alternate_names": ["Akamba"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kamba_people",
    "location_description": "Eastern Kenya, Machakos, Kitui, Makueni counties",
    "countries": ["Kenya"],
    "coordinates": {
      "lat": -1.5,
      "lon": 37.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [37, -2.5],
          [38.5, -2.5],
          [38.5, -0.5],
          [37, -0.5],
          [37, -2.5]
        ]
      ]
    }
  },
  {
    "culture": "Khoekhoe",
    "alternate_names": ["Khoikhoi"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Khoikhoi",
    "location_description": "South Africa, Namibia, Botswana",
    "countries": ["South Africa", "Namibia", "Botswana"],
    "coordinates": {
      "lat": -28,
      "lon": 22
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [16, -34],
          [28, -34],
          [28, -22],
          [16, -22],
          [16, -34]
        ]
      ]
    }
  },
  {
    "culture": "Khoikhoi",
    "alternate_names": ["Khoekhoe"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Khoikhoi",
    "location_description": "South Africa, Namibia, Botswana",
    "countries": ["South Africa", "Namibia", "Botswana"],
    "coordinates": {
      "lat": -28,
      "lon": 22
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [16, -34],
          [28, -34],
          [28, -22],
          [16, -22],
          [16, -34]
        ]
      ]
    }
  },
  {
    "culture": "Kikuyu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kikuyu_people",
    "location_description": "Central Kenya, around Mount Kenya",
    "countries": ["Kenya"],
    "coordinates": {
      "lat": -0.7,
      "lon": 37
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [36.5, -1.2],
          [37.5, -1.2],
          [37.5, -0.2],
          [36.5, -0.2],
          [36.5, -1.2]
        ]
      ]
    }
  },
  {
    "culture": "Kom",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kom_people_(Cameroon)",
    "location_description": "Northwest Region, Cameroon",
    "countries": ["Cameroon"],
    "coordinates": {
      "lat": 6,
      "lon": 10.3
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [10, 5.8],
          [10.6, 5.8],
          [10.6, 6.2],
          [10, 6.2],
          [10, 5.8]
        ]
      ]
    }
  },
  {
    "culture": "Kongo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kongo_people",
    "location_description": "Lower Congo River, DRC, Republic of Congo, Angola",
    "countries": [
      "Democratic Republic of Congo",
      "Republic of Congo",
      "Angola"
    ],
    "coordinates": {
      "lat": -4.5,
      "lon": 15
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [12, -6],
          [18, -6],
          [18, -3],
          [12, -3],
          [12, -6]
        ]
      ]
    }
  },
  {
    "culture": "Koniagui",
    "alternate_names": ["Konyagi"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Koniagui_people",
    "location_description": "Southeastern Senegal, northern Guinea",
    "countries": ["Senegal", "Guinea"],
    "coordinates": {
      "lat": 12.5,
      "lon": -12.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-13, 12],
          [-12, 12],
          [-12, 13],
          [-13, 13],
          [-13, 12]
        ]
      ]
    }
  },
  {
    "culture": "Konso",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Konso_people",
    "location_description": "Southern Ethiopia, Konso Zone",
    "countries": ["Ethiopia"],
    "coordinates": {
      "lat": 5.5,
      "lon": 37.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [37, 5],
          [38, 5],
          [38, 6],
          [37, 6],
          [37, 5]
        ]
      ]
    }
  },
  {
    "culture": "Kota",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kota_people_(Gabon)",
    "location_description": "Eastern Gabon, Republic of Congo",
    "countries": ["Gabon", "Republic of Congo"],
    "coordinates": {
      "lat": -0.5,
      "lon": 13.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [12.5, -1.5],
          [14.5, -1.5],
          [14.5, 0.5],
          [12.5, 0.5],
          [12.5, -1.5]
        ]
      ]
    }
  },
  {
    "culture": "Kuba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Kuba_Kingdom",
    "location_description": "Kasai region, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -5,
      "lon": 21
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [20, -6],
          [22, -6],
          [22, -4],
          [20, -4],
          [20, -6]
        ]
      ]
    }
  },
  {
    "culture": "Kung",
    "alternate_names": ["ǃKung", "ǃXun", "Ju", "San", "Bushmen"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/ǃKung_people",
    "location_description": "Kalahari Desert region in northern Namibia, southern Angola, and northwestern Botswana",
    "countries": ["Namibia", "Botswana", "Angola"],
    "coordinates": {
      "lat": -19.5,
      "lon": 20.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [18, -17],
          [23, -17],
          [23, -22],
          [18, -22],
          [18, -17]
        ]
      ]
    }
  },
  {
    "culture": "Lega",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Lega_people",
    "location_description": "South Kivu, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -3,
      "lon": 27.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [26.5, -4],
          [28.5, -4],
          [28.5, -2],
          [26.5, -2],
          [26.5, -4]
        ]
      ]
    }
  },
  {
    "culture": "Lobi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Lobi_people",
    "location_description": "Burkina Faso, northern Ivory Coast, northwestern Ghana",
    "countries": ["Burkina Faso", "Ivory Coast", "Ghana"],
    "coordinates": {
      "lat": 10.5,
      "lon": -3
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-4, 9.5],
          [-2, 9.5],
          [-2, 11.5],
          [-4, 11.5],
          [-4, 9.5]
        ]
      ]
    }
  },
  {
    "culture": "Lozi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Lozi_people",
    "location_description": "Western Zambia, Barotseland",
    "countries": ["Zambia"],
    "coordinates": {
      "lat": -15.5,
      "lon": 23.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [22, -17],
          [25, -17],
          [25, -14],
          [22, -14],
          [22, -17]
        ]
      ]
    }
  },
  {
    "culture": "Luba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Luba_people",
    "location_description": "Southeastern Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -9,
      "lon": 25
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [23, -11],
          [27, -11],
          [27, -7],
          [23, -7],
          [23, -11]
        ]
      ]
    }
  },
  {
    "culture": "Lulua",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Lulua_people",
    "location_description": "Kasai region, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -6,
      "lon": 21.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [20.5, -7],
          [22.5, -7],
          [22.5, -5],
          [20.5, -5],
          [20.5, -7]
        ]
      ]
    }
  },
  {
    "culture": "Maabube",
    "wikipedia_url": null,
    "location_description": "Information not readily available",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Limited documentation"
  },
  {
    "culture": "Maasai",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Maasai_people",
    "location_description": "Southern Kenya, northern Tanzania",
    "countries": ["Kenya", "Tanzania"],
    "coordinates": {
      "lat": -2,
      "lon": 36
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [35, -4],
          [37.5, -4],
          [37.5, 0],
          [35, 0],
          [35, -4]
        ]
      ]
    }
  },
  {
    "culture": "Magwangwara",
    "alternate_names": ["Ngoni"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ngoni_people",
    "location_description": "Malawi, Tanzania, Zambia, Mozambique",
    "countries": ["Malawi", "Tanzania", "Zambia", "Mozambique"],
    "coordinates": {
      "lat": -12,
      "lon": 34
    },
    "geojson": null,
    "notes": "Part of Ngoni people"
  },
  {
    "culture": "Makonde",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Makonde_people",
    "location_description": "Southeastern Tanzania, northern Mozambique",
    "countries": ["Tanzania", "Mozambique"],
    "coordinates": {
      "lat": -11,
      "lon": 39
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [38, -12],
          [40, -12],
          [40, -10],
          [38, -10],
          [38, -12]
        ]
      ]
    }
  },
  {
    "culture": "Malian",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Malians",
    "location_description": "Mali",
    "countries": ["Mali"],
    "coordinates": {
      "lat": 17,
      "lon": -4
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Mambwe",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mambwe_people",
    "location_description": "Northeastern Zambia, southwestern Tanzania",
    "countries": ["Zambia", "Tanzania"],
    "coordinates": {
      "lat": -9.5,
      "lon": 31.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [31, -10],
          [32, -10],
          [32, -9],
          [31, -9],
          [31, -10]
        ]
      ]
    }
  },
  {
    "culture": "Mande",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mand%C3%A9_peoples",
    "location_description": "West Africa - Mali, Guinea, Ivory Coast, Senegal, Sierra Leone, Liberia",
    "countries": [
      "Mali",
      "Guinea",
      "Ivory Coast",
      "Senegal",
      "Sierra Leone",
      "Liberia",
      "Burkina Faso"
    ],
    "coordinates": {
      "lat": 10,
      "lon": -8
    },
    "geojson": null,
    "notes": "Large linguistic group across West Africa"
  },
  {
    "culture": "Mangbetu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mangbetu_people",
    "location_description": "Northeastern Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": 3,
      "lon": 28
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [27, 2],
          [29, 2],
          [29, 4],
          [27, 4],
          [27, 2]
        ]
      ]
    }
  },
  {
    "culture": "Maroon",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Maroons",
    "location_description": "Americas - Jamaica, Suriname, other Caribbean locations",
    "countries": ["Jamaica", "Suriname", "various Caribbean nations"],
    "coordinates": null,
    "geojson": null,
    "notes": "Diaspora populations of escaped enslaved Africans, not native to Africa"
  },
  {
    "culture": "Mbole",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mbole_people",
    "location_description": "Tshopo Province, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": 0.5,
      "lon": 25
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [24, 0],
          [26, 0],
          [26, 1],
          [24, 1],
          [24, 0]
        ]
      ]
    }
  },
  {
    "culture": "Mbosi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mboshi_people",
    "location_description": "Plateaux Region, Republic of Congo",
    "countries": ["Republic of Congo"],
    "coordinates": {
      "lat": -1.5,
      "lon": 15.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [14.5, -2.5],
          [16.5, -2.5],
          [16.5, -0.5],
          [14.5, -0.5],
          [14.5, -2.5]
        ]
      ]
    }
  },
  {
    "culture": "Mekan",
    "wikipedia_url": null,
    "location_description": "Information not readily available",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Limited documentation"
  },
  {
    "culture": "Mende",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mende_people",
    "location_description": "Southern and eastern Sierra Leone",
    "countries": ["Sierra Leone"],
    "coordinates": {
      "lat": 7.8,
      "lon": -11.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-12.5, 7],
          [-10.5, 7],
          [-10.5, 8.5],
          [-12.5, 8.5],
          [-12.5, 7]
        ]
      ]
    }
  },
  {
    "culture": "Merina",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Merina_people",
    "location_description": "Central Highlands of Madagascar",
    "countries": ["Madagascar"],
    "coordinates": {
      "lat": -19,
      "lon": 47
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [46.5, -20],
          [47.5, -20],
          [47.5, -18],
          [46.5, -18],
          [46.5, -20]
        ]
      ]
    }
  },
  {
    "culture": "Merina (Malagasy people)",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Merina_people",
    "location_description": "Central Highlands of Madagascar",
    "countries": ["Madagascar"],
    "coordinates": {
      "lat": -19,
      "lon": 47
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [46.5, -20],
          [47.5, -20],
          [47.5, -18],
          [46.5, -18],
          [46.5, -20]
        ]
      ]
    }
  },
  {
    "culture": "Meroitic",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Meroitic_language",
    "location_description": "Ancient Nubia, modern Sudan",
    "countries": ["Sudan"],
    "coordinates": {
      "lat": 16,
      "lon": 33
    },
    "geojson": null,
    "notes": "Ancient civilization, no longer extant as distinct culture"
  },
  {
    "culture": "Mossi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mossi_people",
    "location_description": "Central Burkina Faso",
    "countries": ["Burkina Faso"],
    "coordinates": {
      "lat": 12.5,
      "lon": -1.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-3, 11],
          [0, 11],
          [0, 12],
          [-3, 12],
          [-3, 11]
        ]
      ]
    }
  },
  {
    "culture": "Mozambiquean",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mozambicans",
    "location_description": "Mozambique",
    "countries": ["Mozambique"],
    "coordinates": {
      "lat": -18,
      "lon": 35
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Mpondomise",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mpondomise_people",
    "location_description": "Eastern Cape, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -31,
      "lon": 28
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [27, -32],
          [29, -32],
          [29, -30],
          [27, -30],
          [27, -32]
        ]
      ]
    }
  },
  {
    "culture": "Mumuye",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mumuye_people",
    "location_description": "Taraba State, northeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 8.5,
      "lon": 10.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [10, 8],
          [11, 8],
          [11, 9],
          [10, 9],
          [10, 8]
        ]
      ]
    }
  },
  {
    "culture": "Mundang",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mundang_people",
    "location_description": "Northern Cameroon, southwestern Chad",
    "countries": ["Cameroon", "Chad"],
    "coordinates": {
      "lat": 9,
      "lon": 14.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [14, 8.5],
          [15, 8.5],
          [15, 9.5],
          [14, 9.5],
          [14, 8.5]
        ]
      ]
    }
  },
  {
    "culture": "Muslims",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Islam",
    "location_description": "Global",
    "countries": ["Multiple - global"],
    "coordinates": null,
    "geojson": null,
    "notes": "Religious category, not a specific culture"
  },
  {
    "culture": "Nalu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Nalu_people",
    "location_description": "Coastal Guinea, Guinea-Bissau",
    "countries": ["Guinea", "Guinea-Bissau"],
    "coordinates": {
      "lat": 10.8,
      "lon": -14.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-15, 10.5],
          [-14, 10.5],
          [-14, 11],
          [-15, 11],
          [-15, 10.5]
        ]
      ]
    }
  },
  {
    "culture": "Ndebele",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ndebele_people",
    "location_description": "Zimbabwe, northeastern South Africa",
    "countries": ["Zimbabwe", "South Africa"],
    "coordinates": {
      "lat": -20,
      "lon": 29
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [27, -22],
          [31, -22],
          [31, -18],
          [27, -18],
          [27, -22]
        ]
      ]
    }
  },
  {
    "culture": "Nigerian",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Nigerians",
    "location_description": "Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 9,
      "lon": 8
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "North African",
    "wikipedia_url": null,
    "location_description": "North Africa - Maghreb region",
    "countries": ["Morocco", "Algeria", "Tunisia", "Libya", "Egypt"],
    "coordinates": {
      "lat": 28,
      "lon": 10
    },
    "geojson": null,
    "notes": "Regional category, not a specific culture"
  },
  {
    "culture": "Nuba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Nuba_people",
    "location_description": "Sudan",
    "countries": ["Sudan"],
    "coordinates": {
      "lat": 12.017,
      "lon": 31.100
    },
    "geojson": null
  },
  {
    "culture": "Nupe",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Nupe_people",
    "location_description": "Niger State, central Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 9,
      "lon": 6.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5.5, 8],
          [7.5, 8],
          [7.5, 10],
          [5.5, 10],
          [5.5, 8]
        ]
      ]
    }
  },
  {
    "culture": "Nyanja",
    "alternate_names": ["Chewa", "Chinyanja"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Chewa_people",
    "location_description": "Malawi, Zambia, Mozambique",
    "countries": ["Malawi", "Zambia", "Mozambique"],
    "coordinates": {
      "lat": -14,
      "lon": 33
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [31, -16],
          [35, -16],
          [35, -12],
          [31, -12],
          [31, -16]
        ]
      ]
    }
  },
  {
    "culture": "Okpella",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Okpella",
    "location_description": "Etsako East LGA, Edo State, Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.2,
      "lon": 6.2
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [6, 7],
          [6.4, 7],
          [6.4, 7.4],
          [6, 7.4],
          [6, 7]
        ]
      ]
    }
  },
  {
    "culture": "Ovimbundu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ovimbundu",
    "location_description": "Central Angola",
    "countries": ["Angola"],
    "coordinates": {
      "lat": -12.5,
      "lon": 15.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [14, -14],
          [17, -14],
          [17, -11],
          [14, -11],
          [14, -14]
        ]
      ]
    }
  },
  {
    "culture": "Papel",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Papel_people",
    "location_description": "Bissau region, Guinea-Bissau",
    "countries": ["Guinea-Bissau"],
    "coordinates": {
      "lat": 11.8,
      "lon": -15.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-16, 11.5],
          [-15, 11.5],
          [-15, 12],
          [-16, 12],
          [-16, 11.5]
        ]
      ]
    }
  },
  {
    "culture": "Pende",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Pende_people",
    "location_description": "Kasai and Kwilu provinces, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -5.5,
      "lon": 19.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [18, -7],
          [21, -7],
          [21, -4],
          [18, -4],
          [18, -7]
        ]
      ]
    }
  },
  {
    "culture": "Pondo",
    "alternate_names": ["Mpondo"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Mpondo_people",
    "location_description": "Eastern Cape, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -31.5,
      "lon": 29
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [28.5, -32],
          [30, -32],
          [30, -31],
          [28.5, -31],
          [28.5, -32]
        ]
      ]
    }
  },
  {
    "culture": "Popo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Popo_people",
    "location_description": "Coastal Benin and Togo",
    "countries": ["Benin", "Togo"],
    "coordinates": {
      "lat": 6.3,
      "lon": 1.7
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [1.2, 6],
          [2.2, 6],
          [2.2, 6.6],
          [1.2, 6.6],
          [1.2, 6]
        ]
      ]
    }
  },
  {
    "culture": "Prehistoric peoples",
    "wikipedia_url": null,
    "location_description": "Various locations globally",
    "countries": ["Multiple - global"],
    "coordinates": null,
    "geojson": null,
    "notes": "Not a specific culture"
  },
  {
    "culture": "San",
    "alternate_names": ["Bushmen"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/San_people",
    "location_description": "Kalahari Desert - Botswana, Namibia, Angola, South Africa",
    "countries": ["Botswana", "Namibia", "Angola", "South Africa"],
    "coordinates": {
      "lat": -22,
      "lon": 21
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [18, -26],
          [26, -26],
          [26, -18],
          [18, -18],
          [18, -26]
        ]
      ]
    }
  },
  {
    "culture": "Senufo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Senufo_people",
    "location_description": "Northern Ivory Coast, southern Mali, southwestern Burkina Faso",
    "countries": ["Ivory Coast", "Mali", "Burkina Faso"],
    "coordinates": {
      "lat": 9.5,
      "lon": -5.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-7, 8],
          [-4, 8],
          [-4, 11],
          [-7, 11],
          [-7, 8]
        ]
      ]
    }
  },
  {
    "culture": "Sherbro",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Sherbro_people",
    "location_description": "Southern Sierra Leone",
    "countries": ["Sierra Leone"],
    "coordinates": {
      "lat": 7.5,
      "lon": -12.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-13, 7],
          [-12, 7],
          [-12, 8],
          [-13, 8],
          [-13, 7]
        ]
      ]
    }
  },
  {
    "culture": "Shi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Shi_people",
    "location_description": "South Kivu, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -2.5,
      "lon": 28.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [28, -3],
          [29, -3],
          [29, -2],
          [28, -2],
          [28, -3]
        ]
      ]
    }
  },
  {
    "culture": "Shilluk",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Shilluk_people",
    "location_description": "Upper Nile State, South Sudan",
    "countries": ["South Sudan"],
    "coordinates": {
      "lat": 10,
      "lon": 32
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [31.5, 9],
          [32.5, 9],
          [32.5, 11],
          [31.5, 11],
          [31.5, 9]
        ]
      ]
    }
  },
  {
    "culture": "Shona",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Shona_people",
    "location_description": "Zimbabwe, southern Mozambique, southern Zambia",
    "countries": ["Zimbabwe", "Mozambique", "Zambia"],
    "coordinates": {
      "lat": -19,
      "lon": 31
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [28, -22],
          [34, -22],
          [34, -16],
          [28, -16],
          [28, -22]
        ]
      ]
    }
  },
  {
    "culture": "Siculo-Punic",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Siculo-Punic",
    "location_description": "Ancient Sicily",
    "countries": ["Italy (Sicily)"],
    "coordinates": {
      "lat": 37.5,
      "lon": 14
    },
    "geojson": null,
    "notes": "Ancient culture, not native to Africa"
  },
  {
    "culture": "Sierra Leoneans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Sierra_Leoneans",
    "location_description": "Sierra Leone",
    "countries": ["Sierra Leone"],
    "coordinates": {
      "lat": 8.5,
      "lon": -11.5
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Somali",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Somalis",
    "location_description": "Somalia, Djibouti, eastern Ethiopia, northeastern Kenya",
    "countries": ["Somalia", "Djibouti", "Ethiopia", "Kenya"],
    "coordinates": {
      "lat": 5,
      "lon": 46
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [41, 0],
          [51, 0],
          [51, 10],
          [41, 10],
          [41, 0]
        ]
      ]
    }
  },
  {
    "culture": "Somalis",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Somalis",
    "location_description": "Somalia, Djibouti, eastern Ethiopia, northeastern Kenya",
    "countries": ["Somalia", "Djibouti", "Ethiopia", "Kenya"],
    "coordinates": {
      "lat": 5,
      "lon": 46
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [41, 0],
          [51, 0],
          [51, 10],
          [41, 10],
          [41, 0]
        ]
      ]
    }
  },
  {
    "culture": "Songhai",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Songhai_people",
    "location_description": "Niger River valley, Mali, Niger, Benin",
    "countries": ["Mali", "Niger", "Benin"],
    "coordinates": {
      "lat": 16,
      "lon": 0
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-2, 14],
          [2, 14],
          [2, 18],
          [-2, 18],
          [-2, 14]
        ]
      ]
    }
  },
  {
    "culture": "Songye",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Songye_people",
    "location_description": "Kasai, Katanga, and Maniema provinces, Democratic Republic of Congo",
    "countries": ["Democratic Republic of Congo"],
    "coordinates": {
      "lat": -6.5,
      "lon": 24
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [23, -8],
          [25, -8],
          [25, -5],
          [23, -5],
          [23, -8]
        ]
      ]
    }
  },
  {
    "culture": "Soninke",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Soninke_people",
    "location_description": "Mali, Senegal, Mauritania",
    "countries": ["Mali", "Senegal", "Mauritania"],
    "coordinates": {
      "lat": 15,
      "lon": -9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-12, 13],
          [-7, 13],
          [-7, 17],
          [-12, 17],
          [-12, 13]
        ]
      ]
    }
  },
  {
    "culture": "Sotho",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Sotho_people",
    "location_description": "Lesotho, Free State South Africa",
    "countries": ["Lesotho", "South Africa"],
    "coordinates": {
      "lat": -29,
      "lon": 28
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [27, -30.5],
          [29.5, -30.5],
          [29.5, -28],
          [27, -28],
          [27, -30.5]
        ]
      ]
    }
  },
  {
    "culture": "South African",
    "wikipedia_url": "https://en.wikipedia.org/wiki/South_Africans",
    "location_description": "South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -29,
      "lon": 24
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "South Africans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/South_Africans",
    "location_description": "South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -29,
      "lon": 24
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Sura",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Sura_people",
    "location_description": "Bauchi State, northeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 9.5,
      "lon": 9.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [9, 9],
          [10, 9],
          [10, 10],
          [9, 10],
          [9, 9]
        ]
      ]
    }
  },
  {
    "culture": "Swahili",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Swahili_people",
    "location_description": "East African coast - Kenya, Tanzania, Mozambique",
    "countries": ["Kenya", "Tanzania", "Mozambique"],
    "coordinates": {
      "lat": -6,
      "lon": 39
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [38.5, -11],
          [41, -11],
          [41, -1],
          [38.5, -1],
          [38.5, -11]
        ]
      ]
    }
  },
  {
    "culture": "Swahili-speaking peoples",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Swahili_people",
    "location_description": "East African coast - Kenya, Tanzania, Mozambique",
    "countries": ["Kenya", "Tanzania", "Mozambique"],
    "coordinates": {
      "lat": -6,
      "lon": 39
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [38.5, -11],
          [41, -11],
          [41, -1],
          [38.5, -1],
          [38.5, -11]
        ]
      ]
    }
  },
  {
    "culture": "Swazi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Swazi_people",
    "location_description": "Eswatini (Swaziland), eastern South Africa",
    "countries": ["Eswatini", "South Africa"],
    "coordinates": {
      "lat": -26.5,
      "lon": 31.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [30.5, -27.5],
          [32.5, -27.5],
          [32.5, -25.5],
          [30.5, -25.5],
          [30.5, -27.5]
        ]
      ]
    }
  },
  {
    "culture": "Tanzanians",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Tanzanians",
    "location_description": "Tanzania",
    "countries": ["Tanzania"],
    "coordinates": {
      "lat": -6,
      "lon": 35
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Temne",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Temne_people",
    "location_description": "Northern Sierra Leone",
    "countries": ["Sierra Leone"],
    "coordinates": {
      "lat": 8.8,
      "lon": -12.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-13.5, 8],
          [-11.5, 8],
          [-11.5, 9.5],
          [-13.5, 9.5],
          [-13.5, 8]
        ]
      ]
    }
  },
  {
    "culture": "Tiv",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Tiv_people",
    "location_description": "Benue State, central Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 7.5,
      "lon": 9
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [8, 6.5],
          [10, 6.5],
          [10, 8.5],
          [8, 8.5],
          [8, 6.5]
        ]
      ]
    }
  },
  {
    "culture": "Tsonga",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Tsonga_people",
    "location_description": "Southern Mozambique, northeastern South Africa, southern Zimbabwe",
    "countries": ["Mozambique", "South Africa", "Zimbabwe"],
    "coordinates": {
      "lat": -24,
      "lon": 32
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [30, -26],
          [34, -26],
          [34, -22],
          [30, -22],
          [30, -26]
        ]
      ]
    }
  },
  {
    "culture": "Tswana",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Tswana_people",
    "location_description": "Botswana, South Africa, Zimbabwe",
    "countries": ["Botswana", "South Africa", "Zimbabwe"],
    "coordinates": {
      "lat": -24,
      "lon": 25
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [22, -27],
          [28, -27],
          [28, -21],
          [22, -21],
          [22, -27]
        ]
      ]
    }
  },
  {
    "culture": "Tukulor",
    "alternate_names": ["Toucouleur"],
    "wikipedia_url": "https://en.wikipedia.org/wiki/Toucouleur_people",
    "location_description": "Senegal River valley, Senegal, Mali, Mauritania",
    "countries": ["Senegal", "Mali", "Mauritania"],
    "coordinates": {
      "lat": 16,
      "lon": -13
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-15, 15],
          [-11, 15],
          [-11, 17],
          [-15, 17],
          [-15, 15]
        ]
      ]
    }
  },
  {
    "culture": "Twi",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Twi",
    "location_description": "Ashanti and Akan regions, Ghana",
    "countries": ["Ghana"],
    "coordinates": {
      "lat": 6.7,
      "lon": -1.6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-2.5, 6],
          [-0.5, 6],
          [-0.5, 7.5],
          [-2.5, 7.5],
          [-2.5, 6]
        ]
      ]
    }
  },
  {
    "culture": "Ugandans",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Ugandans",
    "location_description": "Uganda",
    "countries": ["Uganda"],
    "coordinates": {
      "lat": 1,
      "lon": 32
    },
    "geojson": null,
    "notes": "National category, not a specific ethnic group"
  },
  {
    "culture": "Unidentified culture",
    "wikipedia_url": null,
    "location_description": "N/A",
    "countries": [],
    "coordinates": null,
    "geojson": null,
    "notes": "Not a specific culture"
  },
  {
    "culture": "Urhobo",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Urhobo_people",
    "location_description": "Delta State, southern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 5.5,
      "lon": 6
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [5.5, 5],
          [6.5, 5],
          [6.5, 6],
          [5.5, 6],
          [5.5, 5]
        ]
      ]
    }
  },
  {
    "culture": "Venda",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Venda_people",
    "location_description": "Limpopo Province, South Africa, southern Zimbabwe",
    "countries": ["South Africa", "Zimbabwe"],
    "coordinates": {
      "lat": -23,
      "lon": 30
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [29.5, -23.5],
          [31, -23.5],
          [31, -22],
          [29.5, -22],
          [29.5, -23.5]
        ]
      ]
    }
  },
  {
    "culture": "Waja",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Waja_people",
    "location_description": "Gombe State, northeastern Nigeria",
    "countries": ["Nigeria"],
    "coordinates": {
      "lat": 10,
      "lon": 11
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [10.5, 9.5],
          [11.5, 9.5],
          [11.5, 10.5],
          [10.5, 10.5],
          [10.5, 9.5]
        ]
      ]
    }
  },
  {
    "culture": "West African",
    "wikipedia_url": null,
    "location_description": "West Africa region",
    "countries": ["Multiple - West Africa"],
    "coordinates": {
      "lat": 10,
      "lon": 0
    },
    "geojson": null,
    "notes": "Regional category, not a specific culture"
  },
  {
    "culture": "West Africans",
    "wikipedia_url": null,
    "location_description": "West Africa region",
    "countries": ["Multiple - West Africa"],
    "coordinates": {
      "lat": 10,
      "lon": 0
    },
    "geojson": null,
    "notes": "Regional category, not a specific culture"
  },
  {
    "culture": "Wolof",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Wolof_people",
    "location_description": "Senegal, Gambia, Mauritania",
    "countries": ["Senegal", "Gambia", "Mauritania"],
    "coordinates": {
      "lat": 14.5,
      "lon": -15
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [-17, 13],
          [-13, 13],
          [-13, 16],
          [-17, 16],
          [-17, 13]
        ]
      ]
    }
  },
  {
    "culture": "Xhosa",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Xhosa_people",
    "location_description": "Eastern Cape, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -32,
      "lon": 27.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [26, -33.5],
          [29, -33.5],
          [29, -30.5],
          [26, -30.5],
          [26, -33.5]
        ]
      ]
    }
  },
  {
    "culture": "Yaka",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Yaka_people",
    "location_description": "Southwestern Democratic Republic of Congo, northern Angola",
    "countries": ["Democratic Republic of Congo", "Angola"],
    "coordinates": {
      "lat": -6,
      "lon": 17.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [16, -7.5],
          [19, -7.5],
          [19, -4.5],
          [16, -4.5],
          [16, -7.5]
        ]
      ]
    }
  },
  {
    "culture": "Yao (Africa)",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Yao_people_(East_Africa)",
    "location_description": "Malawi, Tanzania, Mozambique",
    "countries": ["Malawi", "Tanzania", "Mozambique"],
    "coordinates": {
      "lat": -13,
      "lon": 35
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [34, -15],
          [36, -15],
          [36, -11],
          [34, -11],
          [34, -15]
        ]
      ]
    }
  },
  {
    "culture": "Yoruba",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Yoruba_people",
    "location_description": "Southwestern Nigeria, Benin, Togo",
    "countries": ["Nigeria", "Benin", "Togo"],
    "coordinates": {
      "lat": 7.5,
      "lon": 4
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [2.5, 6],
          [5.5, 6],
          [5.5, 9],
          [2.5, 9],
          [2.5, 6]
        ]
      ]
    }
  },
  {
    "culture": "Zaghawa",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Zaghawa_people",
    "location_description": "Eastern Chad, northwestern Sudan (Darfur)",
    "countries": ["Chad", "Sudan"],
    "coordinates": {
      "lat": 14,
      "lon": 23
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [21, 12],
          [25, 12],
          [25, 16],
          [21, 16],
          [21, 12]
        ]
      ]
    }
  },
  {
    "culture": "Zulu",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Zulu_people",
    "location_description": "KwaZulu-Natal province, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -28.5,
      "lon": 30.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [29, -31],
          [32, -31],
          [32, -26],
          [29, -26],
          [29, -31]
        ]
      ]
    }
  },
  {
    "culture": "Zulu (?)",
    "wikipedia_url": "https://en.wikipedia.org/wiki/Zulu_people",
    "location_description": "KwaZulu-Natal province, South Africa",
    "countries": ["South Africa"],
    "coordinates": {
      "lat": -28.5,
      "lon": 30.5
    },
    "geojson": {
      "type": "Polygon",
      "coordinates": [
        [
          [29, -31],
          [32, -31],
          [32, -26],
          [29, -26],
          [29, -31]
        ]
      ]
    },
    "notes": "Uncertain identification"
  }
]
